const checkEnvironment = function(){
  let u = navigator.userAgent.toLowerCase();
  return {
      isWeixin: u.indexOf('micromessenger') > -1,
      isQQ: u.indexOf('qq/') > -1,
      trident: u.indexOf('trident') > -1, //IE内核
      presto: u.indexOf('presto') > -1, //opera内核
      webKit: u.indexOf('applewebkit') > -1, //苹果、谷歌内核
      gecko: u.indexOf('gecko') > -1 && u.indexOf('khtml') == -1, //火狐内核
      mobile:
          !!u.match(/applewebkit.*mobile.*/) ||
          !!u.match(/applewebkit/), //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/), //ios终端
      android: u.indexOf('android') > -1 || u.indexOf('linux') > -1, //android终端或者uc浏览器
      iPhone: u.indexOf('iphone') > -1 || u.indexOf('mac') > -1, //是否为iPhone或者QQHD浏览器
      iPad: u.indexOf('ipad') > -1, //是否iPad
      webApp: u.indexOf('safari') == -1 //是否web应该程序，没有头部与底部
  };
}

const JsBridge = function(fuc,params = {}){
  let viewPort = checkEnvironment();
  if (
      viewPort.ios ||
      viewPort.iPhone ||
      viewPort.iPad
  ) {
      if(window.webkit){
        window.webkit.messageHandlers[fuc].postMessage(params);

      }
  } else {
      if(window.huilian){
        window.huilian[fuc]();
      }
  }
}

export default JsBridge


// WEBPACK FOOTER //
// ./src/utils/jsBridge.js